module.exports = __webpack_public_path__ + "nc_static/media/sw-pending.a1ec2c07.svg";